import React, { Component } from 'react';
import Translator from '../../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import CUserHomeCalendar from '../../../components/user-home-calendar/main';
import CUserMyCourses from '../../../components/user-my-courses/main';
import Submain from '../../../components/home-page-sub-content/submain';
const T = Translator.create();
const _logger = Log.create('Teacher/Main.tsx');
interface ITeacherHomeState {
    moreLesson: boolean;
}
export class TeacherHome extends React.Component<{}, ITeacherHomeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            moreLesson: false
        };
    }
    showMoreLesson = () => {
        this.setState({ moreLesson: !this.state.moreLesson });
    };
    public render() {
        return (
            // 4lü gösterim için

            // <div >
            //     <div className="student-course">
            //     <div className="container-fluid" style={{padding:'0 8% 1em 8%',background: '#f1f1f1'}}>
            //             <div className="row">
            //                 <CUserMyCourses />
            //             </div>
            //         </div>
            //     </div>
            //     <div className="container-fluid" style={{padding:'0 8%'}}>
            //         <div className="row">
            //         <div className="col-12">
            //                     <div className="grid-3 gap-2" style={{marginTop:'2em'}}>
            //                         <CUserHomeCalendar />
            //                         <Submain />
            //                     </div>
            //                 </div>
            //         </div>
            //     </div>

            // </div>
            <div >
                <div className="student-course area-course">
                    <div className="container-fluid" style={{background: '#f1f1f1' }}>
                        <div className="row">

                                <CUserMyCourses />
                            <CUserHomeCalendar />
                        </div>
                    </div>
                </div>
                <div className="container-fluid" style={{ padding: '1.25em 8%' }}>
                    <div className="row">
                        <Submain />
                    </div>
                </div>
            </div>
        );
    }
}